module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("leO4Y"))).then(() => parcelRequire('dJXJK'));